// extracted by mini-css-extract-plugin
module.exports = {"add-issue":"style_add-issue__pr6J-"};